export default {
    title: 'Attrezzature',
    icon: 'mdi-hammer-screwdriver',
    groups: ['Amministrazione', 'Magazzino', 'Tecnici', 'Tempi&Metodi', 'Qualità'],
    submenu: [
        {title:'Avanzamento ufficio tecnico',route:{name:'ufficio-tecnico-avanzamento'},groups:['Tecnici','Amministrazione','Tempi&Metodi']},
        {
            title: 'Gestione',
            route: {name: 'attrezzature-list'},
        },
        {
            title: 'Industrializzazione',
            route: {name: 'attrezzature-industrializzazione'},
        },
        /*
        {
            title: 'Creazione',
            route: {name: 'attrezzature-edit'},
        },
        */
    ]
}
